import { useState } from "react";
import TeamMemberCard from "./TeamMember";
import TeamMemberDialog from "./TeamMemberDialog";
import Apai1 from "../../assets/Team/1.jpg";
import Apai2 from "../../assets/Team/2.jpg";
import Apai3 from "../../assets/Team/3.jpg";
import Apai4 from "../../assets/Team/4.jpg";
const teamMembersData = [
  {
    id: 1,
    name: "Алмагүл Матан",
    title: "Бас директор ustaz.kids",
    imageSrc: Apai1, // Replace with actual image
    description: `Педагогика ғылымдарының магистрі -орта білім беру ұйымдарында 8 жылдан астам еңбек еткен .
2013 -2020 жылдары аралығында балабақша меңгерушісі қызметін атқарып , 2021 жылдан қазіргі уақытқа дейін Тәрбие Тірегі оқу әдістемелік орталығында басшылық қызметін атқаруда ,сонымен қатар USTAZ.Kids мектепке дейінгі ұйымдар департаментінің тренері қызметін атқарып келеді.`,
  },
  {
    id: 2,
    name: "Фариза Кузенбаева",
    title: "Академиялық директор ustaz.kids",
    imageSrc: Apai3, // Replace with actual image
    description: `Педагогика ғылымдарының магистрі, 2010-2012 жылдары «Балбөбек» балабақшасында тәрбиеші болып жұмыс істеген. 2013 -2014 жылы Алматы қаласындағы «Үкілі Үміт» балабақшасында тәрбиеші 2014 жылдан 2021 жылға дейін әдіскер қызметін атқарған. 2021 жылдан бастап қазіргі уақытқа дейін «Тәрбие Тірегі» оқу-әдістемелік орталығының әдіскері болып қызмет етеді. Сонымен қатар, Фариза Күзенбаева USTAZ.Kids мектепке дейінгі ұйымдар департаментінің тренері , KIDSTEAM.KZ платформасының әдіскері және «Балабақша Guide» кітабының авторы болып табылады.`,
  },
  {
    id: 3,
    name: "Гүлнұр Дайрабаева",
    title: "Методист-тренер",
    imageSrc: Apai4, // Replace with actual image
    description: `2011-2013 жылдары «Думан» балабақшасында тәрбиеші, 2013-2021 жылдары халықаралық “Spectrum” балабақшасында тәрбиеші болып жұмыс істеген. Сонымен қатар, 2021-2023 жылдар аралығында балабақшада әдіскер қызметін атқарған. 2023 жылдан бастап қазіргі уақытқа дейін «Тәрбие Тірегі» оқу-әдістемелік орталығында және KIDSTEAM.KZ платформасында әдіскер болып қызмет етіп келеді, сондай-ақ USTAZ.Kids мектепке дейінгі ұйымдар департаментінің тренері қызметін атқаруда`,
  },
  {
    id: 4,
    name: "Гулимжан Мырзабекова",
    title: "Методист-тренер",
    imageSrc: Apai2, // Replace with actual image
    description: `Педагогика ғылымының магистрі, білім беруде 20 жылдық тәжірибесі бар. Оның басым бөлігі меткепке ұйымдар саласында, нақты айтқанда 2024-2021 жылдар арасында балабақша меңгерушісі, 2021 жылдан бері қазіргі кезде “Тәрбие тірегі” орталығының әдіскері, USTAZ.kids мектепке дейінгі ұйымдар департаментінің тренері қызметін атқаруда.`,
  },
  // The fifth member has been removed from this array.
];
const Team = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const handleOpenDialog = (member) => {
    setSelectedMember(member);
  };

  const handleCloseDialog = () => {
    setSelectedMember(null);
  };

  return (
    <div className=" bg-gray-50 py-12 px-4 sm:px-4 lg:px-6 font-sans">
      <div className="container mx-auto px-6">
        <h1 className="text-4xl md:text-5xl font-bold text-[#674DA2] text-center mb-12">
          Ustaz Kids Kомандасы
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-4 gap-8">
          {" "}
          {/* Adjusted lg:grid-cols-4 to lg:grid-cols-5 to better accommodate 4 members, or you can set it to lg:grid-cols-4 if that's preferred */}
          {teamMembersData.map((member) => (
            <TeamMemberCard
              key={member.id}
              member={member}
              onOpenDialog={handleOpenDialog}
            />
          ))}
        </div>
      </div>
      {selectedMember && (
        <TeamMemberDialog member={selectedMember} onClose={handleCloseDialog} />
      )}
    </div>
  );
};

export default Team;
